import { render, staticRenderFns } from "./ProducerStore.vue?vue&type=template&id=6666ae6c&scoped=true&"
import script from "./ProducerStore.vue?vue&type=script&lang=js&"
export * from "./ProducerStore.vue?vue&type=script&lang=js&"
import style0 from "./ProducerStore.vue?vue&type=style&index=0&id=6666ae6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6666ae6c",
  null
  
)

export default component.exports